import {ProjectClient} from '@customink/project-service-client';
import remoteServices from '~/constants/RemoteServices';

export default new ProjectClient({
  hostName: remoteServices.projects
});
